import { ICurrencyWithBalance, ICurrencyWithBalanceAndRate } from '../store/fetchers/currencies'
import { WalletType } from '../store/fetchers/wallets/types'

export default function mapCurrenciesAndWallets(
  wallets: WalletType[],
  currencies: ICurrencyWithBalance[],
): ICurrencyWithBalanceAndRate[] {
  if (!currencies || !currencies?.length) {
    return []
  }

  if (!wallets || !wallets?.length) {
    return currencies
  }

  const mappedCurrencies: ICurrencyWithBalanceAndRate[] = currencies.map((currency) => ({ ...currency }))
  for (const wallet of wallets) {
    const cur = mappedCurrencies.find(
      (c) =>
        c.code.toUpperCase() === wallet.code.toUpperCase() && c.network.toUpperCase() === wallet.network.toUpperCase(),
    )

    if (cur) {
      cur.rate = wallet.rate
    }
  }
  return mappedCurrencies
}
